export const listCacheCategories = async apiCall => {
  const response = await apiCall("/system/cache/list", "POST", {}, "admin");

  return response;
};

export const resetCache = async (apiCall, cluster, prefix) => {
  const requestData = {
    cluster: cluster,
    prefix: prefix,
  };

  const response = await apiCall(
    "/system/cache/reset",
    "POST",
    requestData,
    "admin",
  );

  return response;
};
